/**
 * Convert S3 key to proxy URL for accessing private S3 files through the CRM API
 * @param s3Key - The S3 key (e.g., "blog-images/abc123.webp")
 * @returns Proxy URL or undefined if s3Key is invalid
 */
export const s3KeyToProxyUrl = (s3Key?: string): string | undefined => {
  if (!s3Key) return undefined;
  
  // Only blog images are accessible through the proxy
  if (!s3Key.startsWith('blog-images/')) {
    console.warn(`S3 key does not start with blog-images/: ${s3Key}`);
    return undefined;
  }
  
  const apiUrl = process.env.REACT_APP_API_URL || '/api';
  return `${apiUrl}/uploads/proxy/${s3Key}`;
};

/**
 * Get the best available image URL for a blog
 * Prefers S3 key (converted to proxy URL) over presigned URL
 * @param featuredImage - The presigned S3 URL (may be expired)
 * @param featuredImageS3Key - The S3 key for generating fresh proxy URL
 * @returns Best available image URL
 */
export const getBlogImageUrl = (featuredImage?: string, featuredImageS3Key?: string): string | undefined => {
  // Prefer S3 key if available (generates fresh proxy URL)
  if (featuredImageS3Key) {
    return s3KeyToProxyUrl(featuredImageS3Key);
  }
  
  // Fall back to presigned URL (may be expired)
  return featuredImage;
};
